import React from "react";
import { LayoutGrid, LogOut, Slice, User } from "lucide-react";

import { Button } from "../ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";

import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../store/slices/superAdmin";

export function UserNav() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state?.superAdmin?.user);
  const handleLogout = () => {
    dispatch(setUser(null));
    localStorage.clear();
    navigate("/login");
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="relative h-8 w-8 rounded-full bg-lightGray border-0 hover:bg-body"
        >
          <Avatar className="h-8 w-8">
            <AvatarImage src={user?.profile} alt="Avatar" />
            <AvatarFallback className="bg-transparent">
              {user?.name && user?.name.slice(0, 1).toUpperCase()}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="w-56 bg-lightGray text-white border border-white/20 "
        align="end"
        forceMount
      >
        <DropdownMenuLabel className="font-normal border-b-0">
          <div className="flex flex-col space-y-1 pb-2">
            <p className="text-sm font-medium leading-none ">
              {user?.name || user?.admintype}
            </p>
            <p className="text-xs leading-none ">
              {user?.email || "johndoe@gmail.com"}
            </p>
          </div>
        </DropdownMenuLabel>
        {/* {user?.admintype === "Admin" && (
          <div className="py-1 border-t border-white/20">
            <DropdownMenuGroup>
              <DropdownMenuItem className="hover:cursor-pointer" asChild>
                <div
                  onClick={() => navigate("/profile")}
                  className="flex items-center"
                >
                  <User className="w-4 h-4 mr-3" />
                  Profile
                </div>
              </DropdownMenuItem>
            </DropdownMenuGroup>
          </div>
        )} */}

        <div className="py-1 border-t border-white/20">
          <DropdownMenuGroup>
            <DropdownMenuItem className="hover:cursor-pointer" asChild>
              <div
                onClick={() => navigate("/profile")}
                className="flex items-center"
              >
                <User className="w-4 h-4 mr-3" />
                Profile
              </div>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </div>

        <div className="py-1 border-t border-border">
          <DropdownMenuItem
            className="hover:cursor-pointer"
            onClick={handleLogout}
          >
            <LogOut className="w-4 h-4 mr-3 text-destructive" />
            Log Out
          </DropdownMenuItem>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
